export const getMainCategoryFromPath = (pathname: string): string => {
  // Authentication & Preferences
  if (pathname.startsWith('/login')) return 'Authentication';
  if (pathname.startsWith('/manage-preferences')) return 'Preferences';
  if (pathname.startsWith('/access-denied')) return 'Access Control';

  // Customer & HCP Management
  if (pathname.startsWith('/customer-focus')) return 'Customer Focus';
  if (pathname.startsWith('/personalized-engagement')) return 'Personalized Engagement';
  if (pathname.startsWith('/search-hcps')) return 'HCP Search';
  if (pathname.startsWith('/my-hcps')) return 'My HCPs';
  if (pathname.startsWith('/hcp-overview')) return 'HCP Overview';
  if (pathname.startsWith('/clinical-trial-id')) return 'Clinical Trials';

  // Partner Score & Analysis
  if (pathname.startsWith('/partner-score')) return 'Partner Score';
  if (pathname.startsWith('/competitor-analysis')) return 'Competitor Analysis';

  // Channel Management
  if (pathname.startsWith('/channel-focus')) return 'Channel Focus';
  if (pathname.startsWith('/global-benchmarking')) return 'Global Benchmarking';
  if (pathname.startsWith('/aggregated-consent')) return 'Aggregated Consent';

  // Insights & Analytics
  if (pathname.startsWith('/insights')) return 'Insights';

  return 'Other';
};
